package com.veldekar.components.log

import com.varabyte.kobweb.compose.css.AlignItems.Companion.Center
import com.varabyte.kobweb.compose.css.Overflow.Companion.Hidden
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint.MD
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.px

/**
 * Style for the session list item container.
 * On small screens: vertical layout (column direction)
 * On medium+ screens: horizontal layout (row direction)
 */
val SessionListItemContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(Flex)
            .flexDirection(Column)
            .padding(0.75.cssRem)
            .gap(0.5.cssRem)
    }
    MD {
        Modifier
            .flexDirection(Row)
            .alignItems(Center)
            .gap(1.cssRem)
    }

    // Target the date link text when the container is hovered
    cssRule(":hover .session-date-link") {
        Modifier.textDecorationLine(Underline)
    }
}

/**
 * Style for the session list item image.
 * On small screens: full width, auto height to preserve aspect ratio
 * On medium+ screens: fixed size with cover
 */
val SessionListItemImageStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(auto)
            .objectFit(Contain)
    }
    MD {
        Modifier
            .width(18.9.cssRem)
            .height(10.cssRem)
            .objectFit(Cover)
            .flexShrink(0f)
    }
}

/**
 * Style for the session list item text column.
 */
val SessionListItemTextColumnStyle = CssStyle {
    base {
        Modifier
            .display(Flex)
            .flexDirection(Column)
            .minWidth(0.px)
            .overflow(Hidden)
            .padding(top = 0.5.cssRem, bottom = 0.5.cssRem) // Only vertical padding
    }
    MD {
        Modifier
            .flexGrow(1f)
            .padding(topBottom = 0.5.cssRem)
    }
}
